<div class="report-list-export-loading"
     [class.report-list-export-loading--hidden]="!_exporting"
     role="alertdialog"
     [attr.aria-busy]="_exporting"
     aria-label="Export in progress">
  <div class="report-list-export-loading__backdrop"></div>
  <div class="report-list-export-loading__panel">
    <div class="spinner-border text-warning report-list-export-loading__spinner"
         aria-hidden="true"></div>
    <p class="report-list-export-loading__title">Loading, please wait...</p>
    <div class="report-list-export-loading__progress">
      <div class="progress">
        <div class="progress-bar bg-warning"
             role="progressbar"
             [attr.aria-valuenow]="_exportPercent"
             aria-valuemin="0"
             aria-valuemax="100"
             [style.width]="_exportPercent + '%'"></div>
      </div>
    </div>
    <p class="report-list-export-loading__detail">{{ _exportMessage }}</p>
  </div>
</div>
<app-page-container [title]="tableName">
  <app-messaging-header [tableKey]="tableKey"
                        [folderService]="messageFolderService"
                        [isFolderEmpty]="!data?.length"
                        (folderChanged)="folderSelected($event)">
  </app-messaging-header>

  <app-table [tableKey]="tableKey"
             [displayedColumns]="displayedColumns"
             [data]="data"
             [length]="length"
             [dataType]="dataType"
             (tableData)="getReports($event)"
             (actionEmit)="actionHandler($event)">
  </app-table>
</app-page-container>
